// Trace ID + structured event helper. No observability dep — just typed
// events with JSON-serializable data. Consumers (production logger, scripts,
// audit tooling) wire their own sink via `StageContext.onEvent`.
const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';
/**
 * New trace ID for one pipeline run. Short enough to grep; long enough to
 * be unique across a day of runs.
 */
export function newTraceId() {
    let id = '';
    for (let i = 0; i < 12; i++) {
        id += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
    }
    return id;
}
/**
 * Build a StageEvent and dispatch it to the optional sink. No-op when sink
 * is undefined (the script default).
 */
export function emit(sink, event) {
    if (!sink)
        return;
    sink(event);
}
